export const SAAS_INSTITUTION_SELECTION_EVENT = 'disasterms:saas-institution-selected';

export const readSaaSInstitutionSelection = () => {
  if (typeof window === 'undefined') return '';
  return new URLSearchParams(window.location.search).get('institution') || '';
};

export const selectSaaSInstitution = (institutionId, { updateUrl = true } = {}) => {
  const selectedId = String(institutionId || '').trim();
  if (!selectedId || typeof window === 'undefined') return;

  if (updateUrl && window.location.pathname.startsWith('/saas-administration')) {
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('institution', selectedId);
    window.history.replaceState(window.history.state, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
  }

  window.dispatchEvent(new window.CustomEvent(SAAS_INSTITUTION_SELECTION_EVENT, {
    detail: { institutionId: selectedId },
  }));
};
